import { Layout } from '@/components/Layout/Layout';
import { LegacyThemeRedirect } from '@/features/analyze/components/LegacyThemeRedirect';
import { useGetAnalyzeMethod } from '@/features/analyze/hooks/useGetAnalyzeMethod';
import { AnalyzeForbiddenScreen } from '@/features/analyze/pages/AnalyzeForbiddenScreen';
import { Search } from '@/features/analyze/routes/Search';
import { Transition } from '@/features/analyze/routes/Transition';
import { TreeMap } from '@/features/analyze/routes/TreeMap';
import { CanAccess } from '@/providers/CanAccess';
import { Outlet, Route, Routes } from 'react-router-dom';

const AnalyzeApp = () => {
  const analyzeMethod = useGetAnalyzeMethod();

  // 各ページのコンポーネントを表示すると solr へのリクエストが走るので、
  // 各ページのコンポーネントをマウントする前に権限がない人にはエラーページを表示する
  return (
    <Layout>
      {!analyzeMethod || analyzeMethod === 'search' ? ( // search はみんなが使えるようにする
        <Outlet />
      ) : (
        <CanAccess
          featureKey={analyzeMethod}
          FallbackComponent={<AnalyzeForbiddenScreen />}
        >
          <Outlet />
        </CanAccess>
      )}
    </Layout>
  );
};

export const AnalyzeRoutes = () => {
  return (
    <Routes>
      <Route element={<AnalyzeApp />}>
        <Route path="search" element={<Search />} />
        <Route path="treemap" element={<TreeMap />} />
        <Route path="transition" element={<Transition />} />
      </Route>
      {/* 古いURL形式からのリダイレクト対応 */}
      <Route path=":themeCode/search" element={<LegacyThemeRedirect />} />
      <Route path=":themeCode/treemap" element={<LegacyThemeRedirect />} />
      <Route path=":themeCode/transition" element={<LegacyThemeRedirect />} />
    </Routes>
  );
};
